import { render, staticRenderFns } from "./HelloIndex.vue?vue&type=template&id=8f8cd88e&scoped=true"
import script from "./HelloIndex.vue?vue&type=script&lang=js"
export * from "./HelloIndex.vue?vue&type=script&lang=js"
import style0 from "./HelloIndex.vue?vue&type=style&index=0&id=8f8cd88e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8cd88e",
  null
  
)

export default component.exports